import { render, staticRenderFns } from "./insureregister.vue?vue&type=template&id=4a5847be&scoped=true&"
import script from "./insureregister.vue?vue&type=script&lang=js&"
export * from "./insureregister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5847be",
  null
  
)

export default component.exports